module.exports = __webpack_public_path__ + "img/10.78e05053.png";